import store from '../redux/store/store';
import Category from "../models/Category";

let lastCategoryGroups = null;
let cachedResultsByType = {};

export function clearCategoryGroupCache() {
	cachedResultsByType = {};
	allHashedByType = null;
}

function verifyCacheIsSafeToUseAndUpdateIt() {
	const { categoryGroups } = store.getState().dashboard;
	let isSafe = null;
	if(categoryGroups === lastCategoryGroups) {
		isSafe = true;
	}
	else {
		isSafe = false;
		clearCategoryGroupCache();
	}
	lastCategoryGroups = categoryGroups;
	return isSafe;
}

const getCategoryGroupsByType = (type) => {
	const { categoryGroups } = store.getState().dashboard;

	if(verifyCacheIsSafeToUseAndUpdateIt()) {
		if(cachedResultsByType[type]) {
			return cachedResultsByType[type];
		}
	}
	lastCategoryGroups = categoryGroups;

	let categoryGroupsArray = null;
	if(categoryGroups) {
		categoryGroupsArray = Array.from(categoryGroups);
		categoryGroupsArray.sort(([_, a], [__, b]) => {
			return a.sort_order > b.sort_order ? 1 : -1;
		});
	}

	categoryGroupsArray = categoryGroups ? categoryGroupsArray.map(([key, categoryGroup]) => {
		return categoryGroup;
	}) : null;

	const byType = categoryGroupsArray ? categoryGroupsArray.filter((categoryGroup) => {
		return categoryGroup.type === type;
	}) : [];

	return cachedResultsByType[type] = byType;
};


let allHashedByType = null;

export function getCategoryGroupsById() {
	const { categoryGroups } = store.getState().dashboard;
	const categoryGroupsById = {};
	if(categoryGroups) {
		for(let [id, categoryGroup] of categoryGroups) {
			categoryGroupsById[id] = categoryGroup;
		}
	}
	return categoryGroupsById;
}

export function getAllCategoryGroupsHashedByType() {
	if(verifyCacheIsSafeToUseAndUpdateIt()) {
		if(allHashedByType) {
			return allHashedByType;
		}
	}
	const categoryGroupsByType = {};
	Category.getTypes().forEach((type) => {
		categoryGroupsByType[type.id] = getCategoryGroupsByType(type.id);
	});
	return allHashedByType = categoryGroupsByType;
}

export default getCategoryGroupsByType;